import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAsoodehLandingCoin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={218} height={88} fill='none' {...props}>
    <g opacity={0.5}>
      <path
        fill='url(#asoodehLandingCoin_svg__a)'
        d='m138.199 1.217-2.038 2.105s-2.853 8.875 5.167 24.829c0 0 5.712 12.486 23.93 13.539 18.222 1.052 40.384-11.888 45.415-37.465 0 0 1.565-12.562-7.885-25.577L138.204 1.217z'
      />
      <path
        fill='url(#asoodehLandingCoin_svg__b)'
        d='M183.568 29.136c18.682-9.443 28.539-29.908 22.017-45.709-6.523-15.8-26.955-20.955-45.637-11.512-18.681 9.443-28.538 29.907-22.016 45.708s26.955 20.955 45.636 11.513'
      />
      <path
        stroke='url(#asoodehLandingCoin_svg__c)'
        strokeMiterlimit={10}
        strokeWidth={0.9}
        d='M183.568 29.136c18.682-9.443 28.539-29.908 22.017-45.709-6.523-15.8-26.955-20.955-45.637-11.512-18.681 9.443-28.538 29.907-22.016 45.708s26.955 20.955 45.636 11.513Z'
      />
      <path
        fill='#C16F2A'
        d='M180.931 22.746c14.508-7.333 22.162-23.227 17.096-35.5s-20.933-16.276-35.441-8.942-22.162 23.226-17.097 35.499c5.066 12.272 20.934 16.276 35.442 8.943'
        opacity={0.49}
        style={{
          mixBlendMode: 'multiply',
        }}
      />
      <mask
        id='asoodehLandingCoin_svg__d'
        width={57}
        height={53}
        x={143}
        y={-26}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill='#fff'
          d='M180.931 22.746c14.508-7.333 22.162-23.227 17.096-35.5s-20.933-16.276-35.441-8.942-22.162 23.226-17.097 35.499c5.066 12.272 20.934 16.276 35.442 8.943'
        />
      </mask>
      <g mask='url(#asoodehLandingCoin_svg__d)'>
        <path
          fill='url(#asoodehLandingCoin_svg__e)'
          d='M181.948 23.647c14.508-7.333 22.163-23.226 17.097-35.499-5.066-12.272-20.934-16.276-35.442-8.943s-22.162 23.227-17.096 35.499 20.934 16.276 35.441 8.943'
        />
      </g>
      <path
        fill='url(#asoodehLandingCoin_svg__f)'
        d='M180.931 22.747c14.508-7.333 22.162-23.227 17.096-35.5s-20.933-16.276-35.441-8.942-22.163 23.226-17.097 35.499c5.066 12.272 20.934 16.276 35.442 8.943'
        opacity={0.49}
        style={{
          mixBlendMode: 'multiply',
        }}
      />
      <g
        opacity={0.11}
        style={{
          mixBlendMode: 'overlay',
        }}
      >
        <mask
          id='asoodehLandingCoin_svg__g'
          width={76}
          height={75}
          x={135}
          y={-33}
          maskUnits='userSpaceOnUse'
          style={{
            maskType: 'luminance',
          }}
        >
          <path
            fill='#fff'
            d='M204.623-18.603c-7.384-14.188-26.824-18.498-44.672-9.479-13.339 6.745-22.18 19.107-23.767 31.38l-.023.024s-2.853 8.875 5.167 24.829c0 0 5.712 12.486 23.93 13.539 18.222 1.053 40.384-11.888 45.415-37.465 0 0 1.344-10.85-6.05-22.828'
          />
        </mask>
        <g fill='#fff' mask='url(#asoodehLandingCoin_svg__g)'>
          <path d='m192.571-53.946-54.288 91.593 5.911 4.29 54.288-91.593zM205.894-44.917l-48.373 95.882-5.915-4.29zM143.109 20.573l48.373-95.887 5.915 4.29zM194.813 9.14l48.373-95.888 5.911 4.29z' />
        </g>
      </g>
    </g>
    <g opacity={0.5}>
      <path
        fill='url(#asoodehLandingCoin_svg__h)'
        d='M1.93-4.402.664-.046C.22 1.477.75 3.136 1.959 4.014c4.094 2.975 14.54 9.178 32.208 10.792 1.376.129 2.648-.846 3.027-2.317l1.038-4.383L1.93-4.396z'
      />
      <path
        fill='url(#asoodehLandingCoin_svg__i)'
        d='M38.232 8.1c-.56 2.04-9.157.955-19.201-2.427S1.3-2.11 1.86-4.15s9.157-.955 19.2 2.427C31.106 1.659 38.793 6.06 38.233 8.1'
      />
      <path
        stroke='url(#asoodehLandingCoin_svg__j)'
        strokeMiterlimit={10}
        strokeWidth={0.24}
        d='M38.232 8.1c-.56 2.04-9.157.955-19.201-2.427S1.3-2.11 1.86-4.15s9.157-.955 19.2 2.427C31.106 1.659 38.793 6.06 38.233 8.1Z'
      />
      <path
        fill='#C16F2A'
        d='M32.82 6.15c-.386 1.395-6.247.652-13.1-1.658-6.854-2.31-12.098-5.306-11.713-6.7s6.247-.652 13.1 1.66c6.854 2.31 12.097 5.304 11.712 6.699'
        opacity={0.49}
        style={{
          mixBlendMode: 'multiply',
        }}
      />
      <mask
        id='asoodehLandingCoin_svg__k'
        width={26}
        height={10}
        x={7}
        y={-3}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill='#fff'
          d='M32.82 6.15c-.386 1.395-6.247.652-13.1-1.658-6.854-2.31-12.098-5.306-11.713-6.7s6.247-.652 13.1 1.66c6.854 2.31 12.097 5.304 11.712 6.699'
        />
      </mask>
      <g mask='url(#asoodehLandingCoin_svg__k)'>
        <path
          fill='url(#asoodehLandingCoin_svg__l)'
          d='M32.761 6.519c-.385 1.394-6.247.652-13.1-1.659C12.807 2.55 7.564-.445 7.949-1.84c.385-1.394 6.247-.651 13.1 1.66 6.854 2.31 12.097 5.305 11.712 6.699'
        />
      </g>
      <g opacity={0.54}>
        <mask
          id='asoodehLandingCoin_svg__m'
          width={39}
          height={21}
          x={0}
          y={-6}
          maskUnits='userSpaceOnUse'
          style={{
            maskType: 'luminance',
          }}
        >
          <path
            fill='#fff'
            d='M21.06-1.723C11.43-4.97 3.132-6.1 1.97-4.39l-.04-.013L.664-.045C.22 1.478.75 3.137 1.959 4.015c4.094 2.975 14.54 9.177 32.208 10.79 1.376.13 2.648-.845 3.027-2.316l1.038-4.383c.56-2.04-7.127-6.441-17.171-9.823z'
          />
        </mask>
        <g mask='url(#asoodehLandingCoin_svg__m)'>
          <path
            fill='#fff'
            d='m18.943-10.774-23.607 39.83 2.57 1.865 23.607-39.83zM24.736-6.855l-21.039 41.7-2.572-1.871zM-2.568 21.627l21.033-41.694 2.572 1.865zM19.912 16.652 40.95-25.043l2.572 1.865z'
            opacity={0.22}
            style={{
              mixBlendMode: 'overlay',
            }}
          />
        </g>
      </g>
    </g>
    <g opacity={0.5}>
      <path
        fill='url(#asoodehLandingCoin_svg__n)'
        d='m84.808 67.75 1.077-.912s1.8-4.203-1.25-12.572c0 0-2.116-6.516-10.767-8.168-8.655-1.652-19.881 3.355-23.543 15.664 0 0-1.366 6.103 2.512 13.11z'
      />
      <path
        fill='url(#asoodehLandingCoin_svg__o)'
        d='M72.973 80.852c9.39-3.497 15.105-12.98 12.766-21.183s-11.847-12.017-21.237-8.52-15.105 12.98-12.766 21.183 11.847 12.016 21.237 8.52'
      />
      <path
        stroke='url(#asoodehLandingCoin_svg__p)'
        strokeMiterlimit={10}
        strokeWidth={0.57}
        d='M72.973 80.852c9.39-3.497 15.105-12.98 12.766-21.183s-11.847-12.017-21.237-8.52-15.105 12.98-12.766 21.183 11.847 12.016 21.237 8.52Z'
      />
      <path
        fill='#C16F2A'
        d='M72.028 77.534c7.293-2.716 11.733-10.082 9.916-16.452s-9.202-9.334-16.496-6.617c-7.293 2.715-11.733 10.082-9.916 16.452s9.202 9.334 16.496 6.617'
        opacity={0.49}
        style={{
          mixBlendMode: 'multiply',
        }}
      />
      <mask
        id='asoodehLandingCoin_svg__q'
        width={28}
        height={26}
        x={55}
        y={53}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill='#fff'
          d='M72.028 77.534c7.293-2.716 11.733-10.082 9.916-16.452s-9.202-9.334-16.496-6.617c-7.293 2.715-11.733 10.082-9.916 16.452s9.202 9.334 16.496 6.617'
        />
      </mask>
      <g mask='url(#asoodehLandingCoin_svg__q)'>
        <path
          fill='url(#asoodehLandingCoin_svg__r)'
          d='M71.585 77.029c7.293-2.716 11.733-10.083 9.916-16.453s-9.202-9.333-16.496-6.617S53.272 64.04 55.09 70.41s9.202 9.334 16.496 6.617'
        />
      </g>
      <path
        fill='url(#asoodehLandingCoin_svg__s)'
        d='M72.028 77.534c7.293-2.716 11.733-10.082 9.916-16.452s-9.202-9.334-16.496-6.617c-7.293 2.715-11.733 10.082-9.916 16.452s9.202 9.334 16.496 6.617'
        opacity={0.49}
        style={{
          mixBlendMode: 'multiply',
        }}
      />
      <mask
        id='asoodehLandingCoin_svg__t'
        width={37}
        height={38}
        x={50}
        y={45}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill='#fff'
          d='M72.973 80.854c6.704-2.497 11.535-8.05 12.898-14.004l.014-.012s1.8-4.204-1.25-12.572c0 0-2.113-6.517-10.768-8.168-8.655-1.652-19.88 3.354-23.542 15.663 0 0-1.177 5.27 1.769 11.64 2.832 7.46 11.907 10.796 20.879 7.453'
        />
      </mask>
      <g mask='url(#asoodehLandingCoin_svg__t)'>
        <path
          fill='#fff'
          d='m78.685 81.53 1.437-63.983-4.001-.117-1.437 63.982zM69.848 81.589l-2.564-64.101 3.999.118zM82.402 27.673l2.567 64.102-3.999-.119zM60.618 50.966l2.563 64.101-3.998-.118z'
          opacity={0.2}
          style={{
            mixBlendMode: 'overlay',
          }}
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id='asoodehLandingCoin_svg__a'
        x1={135.666}
        x2={210.768}
        y1={10.201}
        y2={10.201}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E5AF16' />
        <stop offset={1} stopColor='#B47B19' />
      </linearGradient>
      <linearGradient
        id='asoodehLandingCoin_svg__b'
        x1={171.754}
        x2={171.754}
        y1={-32.804}
        y2={33.869}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F9D95D' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehLandingCoin_svg__c'
        x1={171.754}
        x2={171.754}
        y1={-33.029}
        y2={34.094}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFFFC0' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehLandingCoin_svg__e'
        x1={144.939}
        x2={200.606}
        y1={1.433}
        y2={1.433}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FEC13A' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehLandingCoin_svg__f'
        x1={180.757}
        x2={167.708}
        y1={18.46}
        y2={-2.756}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FEC13A' />
        <stop offset={1} stopColor='#F9CB5D' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='asoodehLandingCoin_svg__h'
        x1={0.506}
        x2={38.232}
        y1={5.202}
        y2={5.202}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E5AF16' />
        <stop offset={1} stopColor='#B47B19' />
      </linearGradient>
      <linearGradient
        id='asoodehLandingCoin_svg__i'
        x1={1.83}
        x2={38.261}
        y1={1.975}
        y2={1.975}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F9D95D' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehLandingCoin_svg__j'
        x1={1.76}
        x2={38.325}
        y1={1.975}
        y2={1.975}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFFFC0' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehLandingCoin_svg__l'
        x1={7.926}
        x2={32.779}
        y1={2.343}
        y2={2.343}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FEC13A' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehLandingCoin_svg__n'
        x1={86.45}
        x2={50.46}
        y1={63.528}
        y2={59.945}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E5AF16' />
        <stop offset={1} stopColor='#B47B19' />
      </linearGradient>
      <linearGradient
        id='asoodehLandingCoin_svg__o'
        x1={67.126}
        x2={71.392}
        y1={82.404}
        y2={49.637}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F9D95D' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehLandingCoin_svg__p'
        x1={67.115}
        x2={71.41}
        y1={82.513}
        y2={49.525}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFFFC0' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehLandingCoin_svg__r'
        x1={81.618}
        x2={54.943}
        y1={67.18}
        y2={64.52}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FEC13A' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehLandingCoin_svg__s'
        x1={65.347}
        x2={70.668}
        y1={56.547}
        y2={67.767}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FEC13A' />
        <stop offset={1} stopColor='#F9CB5D' stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAsoodehLandingCoin;
